import React, { Component } from "react";
import Header from "../components/Header.js";
import icon from "../images/icone-info-step1.png";

export class LoadingTerm extends Component {
  render() {
    return (
      <div className="container h-100">
        <Header logo={this.props.logo} />
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5 ">
            <img src={icon} style={{ maxHeight: "125px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
            <h1 className="card-title fw-bold text-white">ASSINANDO DOCUMENTO</h1>
            <div className="row justify-content-center">
              <div className="col-12 d-grid">
                <main className="position-relative">
                  <div className="loading-bar-container ">
                    <div className=" loading-bar-container loading-bar" />
                  </div>
                  <h5 className="position-absolute start-50 translate-middle mt-4">Aguarde...</h5>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingTerm;
